import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

export const TemplatePagesComponent = React.lazy(
    () => import("@mediaspace-react-components/features-group-page/GroupUsersTemplateComponent")
);

const GroupPage = React.lazy(() => import("@mediaspace-react-components/features-group-page/GroupPage"));
export const render = getDsLayoutComponentRenderer(GroupPage);
